module.exports = __webpack_public_path__ + "img/horizontal_4_2_pp2_6005.ab30c252.png";